import styled from "styled-components";

export const Input = styled.input`
  width: ${(props) => (props.width ? props.width : "")};
  height:${(props) => (props.height ? props.height : "30px")};
  border:1px solid #606060;
  border-radius: 6px;
  cursor:pointer;
  margin: ${(props) => (props.margin ? props.margin : "")};
  padding: 5px 5px 5px 15px;
  padding-left:${(props) => (props.paddingL ? props.paddingL : "")};
  display: ${(props) => (props.display ? props.display : "block")};
  font-size:15px ;
  font-weight: 400;
  background:transparent;
  z-index:1;
  &::hover, &:active, &:focus {
    border: 2px solid #808080;
    outline: none !important;
  }
  ::placeholder{
    font-weight: 400;
    font-size: ${(props) => (props.fontSizeP ? props.fontSizeP : "")};
    color:#a0a0a0
  }
`
;

